// api/query/course.ts

import apiClient from "../config";

export const getCourseInfo = async (courseId: string) => {
  const { data } = await apiClient.get(`/public/getCourseInfo/${courseId}`);
  return data;
};

export const getMemberInfo = async (memberNo: string) => {
  const { data } = await apiClient.get(`/public/getMemberInfo/${memberNo}`);
  return data;
};

export const getUplineMemberNo = async (memberNo: string) => {
  const { data } = await apiClient.get(`/public/getUplineMemberNo/${memberNo}`);
  return data;
};

export const getCourseVideoLink = async (courseId: string) => {
  const { data } = await apiClient.get(
    `/public/getCourseVideoLink/${courseId}`
  );
  return data;
};

export const getCoursePrerequisites = async (courseId: string) => {
  const { data } = await apiClient.get(
    `/public/listCoursePrerequisites/${courseId}`
  );
  return data;
};
